import React from 'react'
import { InferGetServerSidePropsType } from 'next'
import { BuilderComponent } from '@builder.io/react'

import { getServerSideProps } from 'src/pages/builder/server'

import Footer from 'client/components/Footer'
import Page from 'src/comps/Page'
import Header from 'client/components/Header'
import Head from 'client/pages/Home/Head'
import { ListOfAncillary } from '@s4l/stayforlong/booking/ListOfAncillary'

const pagePathView = '/reviews'

export { pagePathView }

type Props = InferGetServerSidePropsType<typeof getServerSideProps> & { pageId: string }

const SimplePage = (props: Props) => {
  const { config, builderContent, pageId } = props
  const { locale } = config

  return (
    <Page config={config} pageId={pageId}>
      <Head />
      <Header pageId={pageId} ancillariesJSON={ListOfAncillary.empty().toJSON()} />
      <BuilderComponent locale={locale} model="page" content={builderContent} />
      <Footer />
    </Page>
  )
}

export default SimplePage
